import { ProductResultsConfigurationRequestModel } from '@clubhub/ignite/models/products';
import {
  MiProductsFiltersViewModel,
  ProductsBridgingModelRequest,
  ProductsBtlModelRequest,
  ProductsResidentialModelRequest,
  SearchType,
} from '@shared/models';
import { LenderProduct } from '@shared/models/mi';
import { InaccuracyReportCategory, InaccuracyReportSubCategory } from './enums';

export interface IInaccuracyReport {
  groupId?: number;
  categoryId: InaccuracyReportCategory;
  subCategoryId?: InaccuracyReportSubCategory;
  report?: string;
  lenderName: string;
  productDescription?: string;
}

export enum InaccuracyReportType
{
  Ignite = 0,
  Audit = 1,
  Products = 2,
  ProductsAudit = 3,
}

export interface IInaccuracyReportRequest {
  affordabilitySearchId?: string | null;
  productsSearchId?: string | null;
  criteriaSearchId?: string | null;
  propertySearchId?: string | null;
  // lenderName?: string;
  reports?: IInaccuracyReport[];
  reportType?: InaccuracyReportType;
  lendingType?: string;
  source: SearchType;
  agencyNumber?: number | null;
  productsFilters: MiProductsFiltersViewModel[];
  products: LenderProduct[];
  productsSearchRequest: ProductsResidentialModelRequest | ProductsBtlModelRequest
    | ProductsBridgingModelRequest | undefined;
  productResultsConfiguration: ProductResultsConfigurationRequestModel | undefined;
  lendersWithMatchedProducts: string[] | undefined;
  lenderAffordabilityData: {
    lenderName: string;
    maximumAffordableLoanAmount: number | null;
    stressRate: number | null;
  }[];
}
